export const HUNDRED = 100;